import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {
  LOADING_INDICATOR_SPINNER_DIALOG_CONFIG,
  LoadingIndicatorSpinnerDialog,
  LoadingIndicatorSpinnerDialogData
} from '@aviary/components/loading-indicator-spinner/loading-indicator-spinner-dialog/loading-indicator-spinner.dialog';

@Component({
  selector: 'mx-loading-indicator-spinner',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingIndicatorSpinnerComponent implements OnInit, OnDestroy {
  @Input() public delayLoad = true;

  private readonly matDialog: MatDialog = inject(MatDialog);

  public ngOnInit(): void {
    this.dialogRef = this.matDialog.open<LoadingIndicatorSpinnerDialog, LoadingIndicatorSpinnerDialogData, void>(
      LoadingIndicatorSpinnerDialog,
      {
        ...LOADING_INDICATOR_SPINNER_DIALOG_CONFIG,
        data: {
          delayLoad: this.delayLoad
        }
      }
    );
  }

  public ngOnDestroy(): void {
    this.dialogRef?.close();
  }

  private dialogRef: MatDialogRef<LoadingIndicatorSpinnerDialog>;
}
